import { motion } from 'framer-motion';

export default function EmptyState({ emoji, title, message, action }) {
  return (
    <motion.div className="text-center py-10 px-4" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <motion.div
        className="text-5xl mb-3"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
      >
        {emoji}
      </motion.div>
      <h3 className="text-ink font-bold text-lg">{title}</h3>
      <p className="text-ink-soft text-sm mt-1 max-w-sm mx-auto">{message}</p>
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </motion.div>
  );
}
